import * as React from 'react';
import { FC } from 'react';

import { useNavigate } from 'react-router-dom';

import ShortCodeConfirmationModalView from './short-code-confirmation-modal.view';
import { useShortCodeConfirmationModal } from './use-short-code-confirmation-modal';

interface IShortCodeConfirmationModalProps {
  onAction?: () => void;
}

const ShortCodeConfirmationModal: FC<IShortCodeConfirmationModalProps> = ({ onAction }) => {
  const navigate = useNavigate();
  const { data, loading } = useShortCodeConfirmationModal();
  const { actionButton, body, header, image } = data?.shortCodeConfirmationModalContent || {};
  const parsedImage = image?.locale?.app;

  const handleAction = () => {
    if (onAction) {
      onAction();
    }
    navigate(actionButton?.buttonPath?.locale || '');
  };

  if (loading || !data || !parsedImage) {
    return null;
  }

  return (
    <ShortCodeConfirmationModalView
      actionText={actionButton?.buttonText?.locale || ''}
      bodyText={body?.locale || ''}
      handleAction={handleAction}
      headerText={header?.locale || ''}
      image={parsedImage}
    />
  );
};

export default ShortCodeConfirmationModal;
